const IconChevronRight = (): JSX.Element => {
  return (
    <>
      <path
        d="M17.7959 13.7317L10.2959 21.2317C10.0846 21.443 9.79791 21.5618 9.49902 21.5618C9.20014 21.5618 8.91349 21.443 8.70215 21.2317C8.4908 21.0203 8.37207 20.7337 8.37207 20.4348C8.37207 20.1359 8.4908 19.8493 8.70215 19.6379L15.4062 12.9358L8.70402 6.23169C8.59937 6.12704 8.51636 6.00281 8.45973 5.86608C8.40309 5.72935 8.37394 5.58281 8.37394 5.43481C8.37394 5.28682 8.40309 5.14028 8.45973 5.00355C8.51636 4.86682 8.59937 4.74259 8.70402 4.63794C8.80867 4.53329 8.9329 4.45028 9.06963 4.39365C9.20636 4.33701 9.3529 4.30786 9.5009 4.30786C9.64889 4.30786 9.79543 4.33701 9.93216 4.39365C10.0689 4.45028 10.1931 4.53329 10.2978 4.63794L17.7978 12.1379C17.9025 12.2426 17.9856 12.3669 18.0422 12.5037C18.0988 12.6405 18.1279 12.7871 18.1277 12.9352C18.1275 13.0833 18.0981 13.2298 18.0412 13.3665C17.9843 13.5032 17.9009 13.6273 17.7959 13.7317Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconChevronRight;
